var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * 특정 장소의 최신 정보로 SearchScreen 캐시를 비동기로 업데이트
 * 실패해도 사용자 경험에 영향 없음
 *
 * @param api - API 인스턴스
 * @param queryClient - React Query 클라이언트
 * @param placeId - 업데이트할 장소 ID
 */
export function updateSearchCacheForPlaceAsync(api, queryClient, placeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const updatedPlace = yield api.getPlaceWithBuildingPost({ placeId });
            const updateFn = (oldData) => {
                if (!oldData)
                    return oldData;
                return oldData.map(item => item.place.id === placeId
                    ? Object.assign(Object.assign({}, item), { place: updatedPlace.data.place, building: updatedPlace.data.building, hasPlaceAccessibility: updatedPlace.data.hasPlaceAccessibility, hasBuildingAccessibility: updatedPlace.data.hasBuildingAccessibility, isAccessibilityRegistrable: updatedPlace.data.isAccessibilityRegistrable, accessibilityInfo: updatedPlace.data.accessibilityInfo }) : item);
            };
            // Update SearchScreen cache
            queryClient.setQueriesData({ queryKey: ['search'] }, updateFn);
            // Update SearchUnconqueredPlaces cache
            queryClient.setQueriesData({ queryKey: ['SearchUnconqueredPlaces'] }, updateFn);
        }
        catch (_) {
            // Silently fail - not critical for user experience
        }
    });
}
